// Remove legacy profile secrets before the router, ACL or any Vue consumer is loaded.
require('./src/auth/accountProfile').readStoredAccountProfile();
require('./src/main.js');
